// store a global EventEmitter instance in the global context
import EventEmitter from "eventemitter3";

export const eventEmitter = new EventEmitter();

export default eventEmitter;
